/**
 * @fileoverview Weekly review route definitions for GTD-style weekly planning.
 */

import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { createRoutes } from '../utils/routeHelpers';

const WeeklyReviewPage = lazy(() => import('../../features/weekly-review/pages/WeeklyReviewPage'));

export const weeklyReviewRoutes: RouteObject[] = createRoutes([
  { path: 'weekly-review', Component: WeeklyReviewPage },
]);
